import { Component, OnChanges, Input, Output, EventEmitter, OnInit, } from '@angular/core';
import { HomeService } from '../../home/home.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-add-to-bundle',
  templateUrl: './add-to-bundle.component.html',
  styleUrls: ['./add-to-bundle.component.css']
})
export class AddToBundleComponent implements OnChanges, OnInit {
  @Input() bundleID: number;
  @Input() projectID: number;
  @Input() project: String;
  @Input() releaseBundle: String;
  @Input() isBundle: boolean;
  @Input() isChild: boolean;
  @Output() dialogClosed: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() needReload: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  versionOptions: { bundle_id: any; project_id: any; };
  releaseVersionData: any[];
  msgs: any[];
  selectedRelease;
  selectedReleases = [];
  responce: any;
  bundleOptions: {};
  pagebundleid: any;

  constructor(private homeService: HomeService, private router: Router, private route: ActivatedRoute, ) { }

  getReleaseVersionForBundle() {
    // console.log('getReleaseVersionForBundle budleid: ', this.bundleID)
    // this.versionOptions = {
    //   bundle_id: this.bundleID,
    //   project_id: this.projectID,
    // };
    this.versionOptions = {
      bundle_id: this.pagebundleid,
      project_id: this.projectID,
    };
    console.log(this.versionOptions);

    this.releaseVersionData = [];
    this.homeService.getReleaseVersionForBundle(this.versionOptions).then(releaseVersion => {

      if (releaseVersion.length != undefined) {
        this.releaseVersionData = releaseVersion;
      } else {
        this.msgs = [];
        this.msgs.push({ severity: 'warn', summary: 'No Data' });
      }
    });
  }

  addToBundle() {
    console.log("addToBundle: ", this.selectedRelease.length);
    for (var i = 0; i < this.selectedRelease.length; i++) {
      this.selectedReleases.push({ release: this.selectedRelease[i].version, id: this.selectedRelease[i].id });
    }
    var rID = this.bundleID;

    this.sendBundleData();

    if (!this.isChild) {
      setTimeout(() => {
        this.router.navigate(['/bundle/' + rID]);
      },
        500);
    } else {
      this.needReload.emit(true);
    }
  }

  sendBundleData() {
    var versionsList = '';
    var idList = '';
    var componentList = '';

    for (var i = 0; i < this.selectedReleases.length; i++) {
      versionsList = versionsList + this.selectedReleases[i].release + ",";
      idList = idList + this.selectedReleases[i].id + ",";
      componentList = ",";
    }

    this.bundleOptions = {
      bundle_id: this.pagebundleid,
      version: versionsList,
      release_id: idList,
      component: componentList,
      connect: idList
    };

    this.homeService.sendReleaseBundleData(this.bundleOptions).then(res => {
      this.responce = res;

      if (this.responce.status === "sent") {
        // getBundleData

        this.msgs = [];
        this.msgs.push({ severity: 'success', summary: 'Release Added' });
        window.location.reload();
        setTimeout(() => {
          this.selectedReleases = [];
        },
          200);
      } else {
        alert(this.responce);
      }
    });

    // this.getReleaseVersionForBundle();
  }

  onclose() {
    this.dialogClosed.emit(false);
  }

  ngOnChanges(): void {
    this.getReleaseVersionForBundle();
  }

  ngOnInit(): void {
    this.getPageBundleId();
    this.getReleaseVersionForBundle();
  }

  getPageBundleId() {
    const url = window.location.href; // Get the current URL
    const parts = url.split('/'); // Split the URL by '/'
    // Get the last part of the URL which should be the desired value
    this.pagebundleid = parseInt(parts[parts.length - 1]);
    console.log('get page bundle id: ', this.pagebundleid);
  }

}
